const domParser = new DOMParser();

const createDocumentFromContent = (blog: Blog) =>
  domParser.parseFromString(blog.content, "text/html");

export default createDocumentFromContent;
